import * as React from 'react';
import { Input, Modal, Button } from 'antd';
import { calculateRecommendedPrice } from 'src/helpers/Prices/calculateRecommendedPrice';
import { calculatePrice } from 'src/helpers/Prices/calculatePrice';
import PriceDisplay from '../PriceDisplay';

interface IPriceInputPriceType {
  currencyId: string;
  priceWithout?: number | null;
  recommendedPriceWithout?: number | null;
  discount?: number | null;
  discountPercent?: number | null;
}

export interface IPriceInputControlProps {
  name?: string;
  disabled?: boolean;
  prices: IPriceInputPriceType[];
  mode: 'recommendedPriceWithout' | 'priceWithout' | 'minimalPrice'
  currencies?: GQL.ICurrency[];
  onChange: Function;
}

interface IPriceInputControlState {
  visible: boolean;
}

export class PriceInputControl extends React.Component<IPriceInputControlProps, IPriceInputControlState> {

  constructor(props: IPriceInputControlProps) {
    super(props);

    this.state = {
      visible: false,
    };

    this.updatePrices(this.props.prices);
  }

  public render() {
    const { prices, mode, currencies } = this.props;

    if (!currencies) {
      return null;
    }

    const primaryCurrency = currencies.find((currency: GQL.ICurrency) => currency.primary === true);

    if (!primaryCurrency) {
      return null;
    }

    const priceField = mode;

    const newPrices = currencies.map(currency => {
      const price = prices.find(p => (p.currencyId === currency.id));

      return {
        currencyId: currency.id,
        [priceField]: price ? price[priceField] : null,
        currencyCode: currency.value,
      };
    });

    const moreCurrencyPrices: Array<string> = [];

    // Render the form using currencies & prices
    let priceFields: Array<JSX.Element> = [];
    for (const price of newPrices) {
      if (price.currencyCode !== primaryCurrency.value) {
        priceFields.push(
          <Input
            key={price.currencyCode}
            name={price.currencyCode}
            type={'number'}
            defaultValue={price[priceField] !== null ? (price as any)[priceField].toString() : ''}
            step="0.01"
            onChange={
              e => {
                if (e.target.value === null || e.target.value === '') {
                  price[priceField] = null;
                } else {
                  price[priceField] = parseFloat(e.target.value);
                }
              }}
            addonAfter={price.currencyCode}
            className="mt-2 mb-2"
            disabled={this.props.disabled}
          />
        );
        if (price[priceField] && price[priceField] !== 0) {
          moreCurrencyPrices.push(`${price.currencyCode} ${PriceDisplay.currencyFormat(price[priceField] as number, price.currencyCode)}`);
        }
      }
    }

    const primaryField = newPrices.find(p => (p.currencyCode === primaryCurrency.value));

    if (!primaryField) {
      return null;
    }

    return (
      <div className="price-input">
        <Input
          name={primaryField.currencyCode}
          type={'number'}
          value={primaryField[priceField] !== null ? (primaryField as any)[priceField].toString() : ''}
          step="0.01"
          onChange={
            e => {
              if (e.target.value === null || e.target.value === '') {
                primaryField[priceField] = null;
              } else {
                if (!isNaN(parseFloat(e.target.value))) {
                  primaryField[priceField] = e.target.value;
                } else {
                  primaryField[priceField] = parseFloat(e.target.value);
                }
              }

              this.updatePrices(newPrices);
            }
          }
          addonAfter={primaryField.currencyCode}
          disabled={this.props.disabled}
        />
        <Button
          disabled={this.props.disabled}
          onClick={e => {
            this.setState({
              visible: true,
            });
          }}
        >
          More
        </Button>

        {moreCurrencyPrices &&
          <small>{moreCurrencyPrices.join(', ')}</small>}

        <Modal
          title={'Additional currencies'}
          destroyOnClose={true}
          visible={this.state.visible}
          onCancel={e => {
            this.updatePrices(this.props.prices);
            this.setState({
              visible: false
            });
          }}
          onOk={e => {
            this.updatePrices(newPrices);
            this.setState({
              visible: false
            });
          }}
          maskClosable={false}
        >
          <div className="additional-currencies">
            {priceFields}
          </div>
        </Modal>
      </div>
    );
  }

  private updatePrices(newPrices: any) {
    if (this.props.disabled === true) {
      return;
    }

    const { mode } = this.props;

    let prices = [...this.props.prices];

    newPrices.map((newPrice: GQL.IPrice) => {
      const price = prices.find((p: GQL.IPrice) => p.currencyId === newPrice.currencyId);
      if (price === undefined) {
        prices.push({
          currencyId: newPrice.currencyId,
          priceWithout: mode !== 'recommendedPriceWithout' ? newPrice.priceWithout : null,
          recommendedPriceWithout: mode === 'recommendedPriceWithout' ? newPrice.recommendedPriceWithout : null, // todo: nemá to být .priceWithout ?
        });
      }
    });

    prices = prices.map((price: GQL.IPrice) => {
      // nová ceny v měně
      const newPrice = newPrices.find((p: GQL.IPrice) => p.currencyId === price.currencyId);
      if (newPrice) {
        // konečná cena
        if (mode !== 'recommendedPriceWithout') {
          newPrice.priceWithout = newPrice.priceWithout;
          newPrice.recommendedPriceWithout = calculateRecommendedPrice({ ...newPrice });
        }
        // bežná (doporučená) cena
        if (mode === 'recommendedPriceWithout') {
          newPrice.recommendedPriceWithout = newPrice.recommendedPriceWithout;
          newPrice.priceWithout = calculatePrice({ ...newPrice });
        }

        return newPrice;
      }

      return price;
    });

    // odeslání změny cen
    this.onChangePrices(prices);
  }

  private onChangePrices(newPrices: IPriceInputPriceType[]) {
    this.props.onChange({
      target: {
        name: this.props.name,
        value: newPrices.map((price: IPriceInputPriceType) => {
          if (price.priceWithout === 0) {
            price.priceWithout = null;
          }
          if (price.recommendedPriceWithout === 0) {
            price.recommendedPriceWithout = null;
          }
          return price;
        }),
      }
    });
  }
}

export default PriceInputControl;


// WEBPACK FOOTER //
// ./src/components/Others/PriceInput/PriceInput.tsx